import { Directive, ElementRef, Inject, OnInit } from '@angular/core';
import { Theme, THEME_TOKEN } from '../../types/theme.types';
import { componentStylesByTheme } from '../../utils/theme.utils';
import { style } from '../../utils/style.utils';
import {
  inputErrorStylesSAG,
  inputErrorStylesSHS,
} from './input-error.styles';

@Directive({
  selector: 'span[sag-ui-input-error]',
})
export class InputErrorDirective implements OnInit {
  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    private readonly elementRef: ElementRef<HTMLSpanElement>
  ) {}

  ngOnInit(): void {
    const inputErrorStyles = componentStylesByTheme(
      this.theme,
      inputErrorStylesSAG,
      inputErrorStylesSHS
    );
    style(this.elementRef, inputErrorStyles());
  }
}
